export type CtaState =
  | 'incomplete'
  | 'ready'
  | 'waiting'
  | 'insufficient'
  | 'unavailable'
  | 'guest'
  | 'submitting';

/** 全程整数分。钱不走浮点。 */
export function totalCents(priceCents: number, quantity: number, rounds: number): number {
  return priceCents * quantity * rounds;
}

/**
 * 优先级刻意如此：submitting > waiting > incomplete > unavailable > guest > insufficient。
 *
 * 一次只向用户提一个问题，且提最近的那个：
 * - 号没选完就先说选号，即使同时余额不足
 * - 号买不到了就别让他去充值，那是浪费一次操作
 * - 未登录用户不说「去充值」—— 他还没有账号（工程契约 §7.1）
 */
export function ctaState(i: {
  complete: boolean;
  phase: 'open' | 'waiting';
  balanceCents: number;
  totalCents: number;
  unavailable: boolean;
  submitting: boolean;
  guest?: boolean;
}): CtaState {
  if (i.submitting) return 'submitting';
  if (i.phase === 'waiting') return 'waiting';
  if (!i.complete) return 'incomplete';
  if (i.unavailable) return 'unavailable';
  if (i.guest) return 'guest';
  if (i.balanceCents < i.totalCents) return 'insufficient';
  return 'ready';
}

/**
 * 订单摘要的四个替换位。
 *
 * 单复数必须分开取词：三种语言的量词都随数量变形，
 * `1 apostas × 1 rodadas` 在巴西人眼里就是一句坏话，
 * 而 1 注 1 期恰恰是新用户最常见的第一单 —— 这句话他一定会看到。
 */
export function summaryParts(quantity: number, rounds: number) {
  return {
    '%q%': String(quantity),
    '%qu%': quantity === 1 ? ('milharUnitBet' as const) : ('milharUnitBets' as const),
    '%r%': String(rounds),
    '%ru%': rounds === 1 ? ('milharUnitRound' as const) : ('milharUnitRounds' as const),
  };
}
